import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SideAreaMap } from "components/Moleculas/Map/Side/SideAreaMap";
import { TitleSidebar } from "components/Atomos/Texts/TitleSidebar";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { reset as resetPonto } from "store/modules/consultaprevia/actions/obterPlanoDiretorNoPonto";
import { ResultadoPonto } from "pages/ConsultaPrevia/components/ResultadoPonto";
import { useCamadas } from "../contexts/CamadasProvider";

export const SidebarPonto = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { selecionarSigla, fichaAberta } = useCamadas();

  const { ponto, isRequesting, successPayload, errors } = useTypedSelector(
    (state) => state.consultaprevia.obterPlanoDiretorNoPonto
  );

  // Realça no mapa a zona que respondeu — o mapa e a lateral falando do mesmo.
  // Enquanto a ficha está aberta quem manda no realce é ela; ao fechar, este
  // efeito roda de novo e devolve o destaque à zona do ponto consultado.
  useEffect(() => {
    if (!ponto || fichaAberta) return;

    selecionarSigla(successPayload?.zona?.sigla ?? null);
  }, [ponto, successPayload?.zona?.sigla, fichaAberta]);

  // A ficha ocupa a mesma lateral: o ponto se recolhe, sem perder o resultado.
  if (!ponto || fichaAberta) return null;

  return (
    <SideAreaMap
      isOpen={true}
      onClose={() => {
        dispatch(resetPonto());
        selecionarSigla(null);
      }}
      size={30}
      zIndex={1000}
    >
      <TitleSidebar>Consulta no ponto</TitleSidebar>

      <ResultadoPonto
        isRequesting={isRequesting}
        resultado={successPayload}
        errors={errors}
        onVerFicha={(sigla) =>
          navigate(`/consulta-previa/zonas/${encodeURIComponent(sigla)}`)
        }
      />
    </SideAreaMap>
  );
};
